
import request from '@/request'
const part_url = 'recruit/pay/';


/**
 * 查询咨询
 *
 * @param {*} noticeId 公告id
 * @returns
 */
function pay(data) {
  let url = part_url + "pay";
  return request.get(url, data)
}
/**
 * 订单支付状态查询
 *@param {*} orderId 订单id
 * @returns
 */
 function payResult(data) {
  let url = part_url + "payResult";
  return request.get(url, data)
}



export default {
    pay,
    payResult
}



// WEBPACK FOOTER //
// ./src/api/pay.js